import moment from "moment";

export default {
  addHoliday() {
    if (this.newHoliday) {
      this.holidays.push(this.newHoliday);
      this.newHoliday = "";
      this.save();
    }
  },
  removeHoliday(i) {
    this.holidays.splice(i, 1);
    this.save();
  },
  formatDate(d) {
    return moment(d).format("YYYY.MM.DD(dd)");
  },
};
